// Solo STUN pubblico per scoprire l'indirizzo: audio e video viaggiano direttamente tra i due browser.
export const ICE = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }, { urls: "stun:stun1.l.google.com:19302" }] };

export const VIDEO_360 = { width: { ideal: 640 }, height: { ideal: 360 }, frameRate: { ideal: 15, max: 20 } };

// Polling dei segnali: onBatch riceve l'elenco nuovo e la risposta completa.
export function startPolling(fetcher, onBatch, ms = 1000) {
  let n = 0;
  let stop = false;
  const tick = async () => {
    if (stop) return;
    try {
      const { data } = await fetcher(n);
      n += data.segnali.length;
      await onBatch(data.segnali, data);
    } catch { /* rete instabile: riprova al giro successivo */ }
    if (!stop) setTimeout(tick, ms);
  };
  tick();
  return () => { stop = true; };
}

// Applica i candidati ICE solo dopo la descrizione remota.
export function iceQueue(pc) {
  const pending = [];
  return {
    add: async (c) => { if (pc.remoteDescription) { try { await pc.addIceCandidate(c); } catch { /* ignora */ } } else pending.push(c); },
    flush: async () => { while (pending.length) { try { await pc.addIceCandidate(pending.shift()); } catch { /* ignora */ } } },
  };
}
